module.exports = __webpack_public_path__ + "static/media/de.0a2a8f86.svg";